import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addObservationParticipantMutation = loader(
  './addObservationParticipant.graphql',
);

export const useObservationMutations = () => {
  const [addIncidentParticipant] = useMutation(
    addObservationParticipantMutation,
  );

  const addParticipant = async ({
    participants = [],
    observationId,
    onComplete = () => {},
  }) => {
    await addIncidentParticipant({
      variables: { id: observationId, participants },
    }).then(() => onComplete());
  };

  return { addParticipant };
};
